{
  "file": {
    "byte": "Byte",
    "bytes": "Bytes",
    "kB": "kB",
    "MB": "MB",
    "GB": "GB",
    "TB": "TB"
  }
}
